import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errorText } from "../lib/api";
import { Logo } from "../components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Studio — BWI";
    let meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.setAttribute("content", "noindex, nofollow");
    api.get("/auth/me").then(() => nav("/studio-admin/dashboard")).catch(() => {});
    return () => { if (meta) meta.setAttribute("content", "index, follow, max-image-preview:large, max-snippet:-1"); };
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/studio-admin/dashboard");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand px-6">
      <form onSubmit={submit} className="w-full max-w-sm border border-line bg-ivory p-10" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-10 font-serif text-3xl text-wine">Studio sign in</h1>
        <div className="mt-8 space-y-6">
          <div>
            <label htmlFor="a-email" className="field-label">Email</label>
            <input id="a-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="admin-login-email" required />
          </div>
          <div>
            <label htmlFor="a-pass" className="field-label">Password</label>
            <input id="a-pass" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="field" data-testid="admin-login-password" required />
          </div>
        </div>
        {error && <p className="mt-6 text-sm text-wine" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn btn-primary mt-10 w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
